<div class="component-container">
  <div *ngIf="printData?.userName" class="heading">
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    *ngIf="printData?.userName"
    class="heading"
  >
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    class="heading flex xs:flex-col sm:flex-row md:flex-row justify-between items-center"
  >
    <div class="title">
      {{ !memberId ? "My " : "" }}Screen Time
      <span class="additional-text">{{ additionalText }}</span>
    </div>
    <div class="controls flex flex-row justify-between items-center">
      <mat-radio-group
        (change)="toggleChart($event)"
        [value]="dailyChart"
        class="flex flex-row items-center"
      >
        <mat-radio-button [value]="true">Daily</mat-radio-button>
        <div class="vertical-divider"></div>
        <mat-radio-button [value]="false">Weekly</mat-radio-button>
      </mat-radio-group>
      <mat-checkbox
        *ngIf="!isAdult"
        [(ngModel)]="showTarget"
        [disabled]="dailyChart"
        (ngModelChange)="toggleTarget()"
        >Show Weekly Goals
      </mat-checkbox>
    </div>
  </div>
  <div
    class="chart-container flex-row flex w-full xs:h-[50rem] sm:h-[50rem] md:h-[50rem]"
  >
    <ng-container *ngIf="dailyChart">
      <div
        *ngIf="groupedBarChartData?.loading"
        class="chart-loader w-full h-full flex justify-center items-center"
      >
        <mat-spinner
          strokeWidth="5"
          [diameter]="60"
        />
      </div>
      <grouped-bar-chart
        *ngIf="groupedBarChartData?.data"
        chartName="screen-time"
        [chartData]="groupedBarChartData.data"
        [showTargetLine]="showTarget"
        [yAxisLabel]="'Duration in Hours'"
        [xAxisLabel]="'Weeks'"
        yAxisLabelFormat="minutesToHrsAndMinutes"
        class="w-full"
      ></grouped-bar-chart>
      <div
        *ngIf="!groupedBarChartData?.loading && !groupedBarChartData?.data"
        class="no-chart-data w-full h-full flex justify-center items-center"
      >
        No data to show on chart.
      </div>
    </ng-container>
    <ng-container *ngIf="!dailyChart">
      <div
        *ngIf="barChartData?.loading"
        class="chart-loader w-full h-full flex justify-center items-center"
      >
        <mat-spinner
          strokeWidth="5"
          [diameter]="60"
        />
      </div>
      <bar-chart
        *ngIf="barChartData?.data"
        chartName="screen-time"
        [chartData]="barChartData.data"
        [showTargetLine]="showTarget"
        [yAxisLabel]="'Duration in Hours'"
        [xAxisLabel]="'Weeks'"
        yAxisLabelFormat="minutesToHrsAndMinutes"
        class="w-full h-full"
      ></bar-chart>
      <div
        *ngIf="!barChartData?.loading && !barChartData?.data"
        class="no-chart-data w-full h-full flex justify-center items-center"
      >
        No data to show on chart.
      </div>
    </ng-container>
  </div>

  <div class="table-container w-full">
    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div
        class="table-wrapper table-container xs:w-[80rem] sm:w-[80rem] md:w-full {{
          printData
            ? ''
            : 'xs:max-h-[85vh] sm:max-h-[85vh] md:max-h-[calc(90vh-6rem)] xl:max-h-[calc(95vh-6rem)] overflow-auto'
        }}"
        infiniteScroll
        (scrolled)="onScroll()"
        [fromRoot]="true"
        [immediateCheck]="true"
        [infiniteScrollDisabled]="
          !(groupedBarChartData?.data || barChartData?.data)
        "
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
      >
        <table
          *ngIf="chartTableData?.data?.list?.length"
          mat-table
          [dataSource]="chartTableData?.data?.list"
          style="table-layout: auto; width: 100%"
        >
          <ng-container matColumnDef="week">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Week
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              mat-cell
              class="w-[10%]"
              *matCellDef="let element"
            >
              {{ element.weekNumber || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateRange">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Date Range
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              mat-cell
              class="w-[20%]"
              *matCellDef="let element"
            >
              {{ element.dateRange.start | date: "MMM dd, yyyy" }} -
              {{ element.dateRange.end | date: "MMM dd, yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sessions">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Session
            </th>
            <td
              style="
                min-width: 12rem;
                max-width: 18rem;
                overflow: visible;
                white-space: nowrap;
              "
              class="sessions-cell w-[18%]"
              mat-cell
              *matCellDef="let element"
            >
              <ng-container *ngIf="element.sessions?.length; else noSessions">
                <div
                  *ngFor="let session of element.sessions"
                  class="td-cell session flex flex-col gap-[1rem]"
                >
                  <div
                    *ngIf="session['sessionNumber']"
                    class="session flex flex-row justify-start items-center gap-x-[1rem]"
                  >
                    <span class="pill-container">
                      S{{ session.sessionNumber | number: "2.0-0" }}
                    </span>
<!--                    <span class="session-date">-->
<!--                      {{ session.date | date: "MMM dd" }}-->
<!--                    </span>-->
                  </div>
                </div>
              </ng-container>
              <ng-template #noSessions>
                <span>-</span>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="weekTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
              >Total Screen Time Duration
            </th>
            <td
              mat-cell
              class="w-[18%]"
              *matCellDef="let element"
            >
              {{ element.total !== null ? (element.total | hrAndMin) : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="weekTarget">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Screen Time Goals
            </th>
            <td
              class="w-[18%]"
              mat-cell
              *matCellDef="let element"
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span>{{ (element.goal | hrAndMin) || "-" }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="dayTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Days journaling screen time
            </th>
            <td
              class="w-[18%]"
              mat-cell
              *matCellDef="let element"
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span>{{ element.days_entered || "-" }}</span>
              </div>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columns"
          ></tr>
          <tr
            class="mat-row"
            *matNoDataRow
          >
            <td
              class="mat-cell"
              [colSpan]="columns.length"
            >
              No data found.
            </td>
          </tr>
        </table>

        <div
          *ngIf="
            ((dailyChart && groupedBarChartData?.data) ||
              (!dailyChart && barChartData?.data)) &&
            chartTableData?.loading
          "
          class="chart-table-loader w-full h-[10rem] flex justify-center items-center"
        >
          <mat-spinner
            strokeWidth="5"
            [diameter]="60"
          />
        </div>
      </div>
    </div>
  </div>
</div>
